<template>
  <div class="buyerDetail">
    <!--  -->
    <div class="contentBox">
      <div class="top">
        <div class="gback" @click="$router.go(-1)">
          <md-icon name="arrow-left" size="sm"></md-icon>
          <span>返回</span>
        </div>
        <div class="searchPart">
          <ul v-if="listQuery.buyer_id!=1">
            <li
              v-for="(item, index) in tabLists"
              :key="index"
              @click="toggleTabs(item.value)"
              :class="nowClick == item.value?'':'active'"
            >{{ item.title }}</li>
          </ul>
          <ul v-else>
            <li>全部订单</li>
          </ul>
          <div class="time">
            <Calendar v-model="searchTime" @change="getTime"></Calendar>
          </div>
        </div>
      </div>
      <div class="detail">
        <!-- 左 -->
        <div class="shop_part">
          <!-- 店铺详情部分 -->
          <div class="shop_info brt4">
            <div class="shop_infotop">
              <div class="tlbox">
                <div class="tl">
                  <div>
                    <span>{{buyerInfo.name}}</span>
                  </div>
                  <div @click="edit()" v-if="listQuery.buyer_id!=1">
                    <!-- <md-icon name="edit" size="sm" style="color:#31B158;font-weight:bold"></md-icon> -->
                    <i class="iconfont icon-bianji" style="color:#31b158;font-size:0.24rem"></i>
                  </div>
                </div>
                <div class="phone">{{buyerInfo.mobile}}</div>
              </div>
              <!-- 采购统计 -->
              <div class="buyCountPart">
                <div class="buyCount">
                  <div>采购统计</div>
                  <div>
                    <span>采购单数：</span>
                    <span>{{buyerInfo.order_count||0}}单</span>
                  </div>
                  <div>
                    <span>采购金额：</span>
                    <span>{{buyerInfo.receivables_total*1||0}}元</span>
                  </div>
                  <div v-if="listQuery.buyer_id!=1">
                    <span>赊欠金额：</span>
                    <span>{{buyerInfo.credit_amount*1||0}}元</span>
                  </div>
                </div>
              </div>
              <!-- 赊欠记录 -->
              <div class="creditPart" v-if="listQuery.buyer_id!=1">
                <div>赊欠记录</div>
                <div>
                  <span>赊欠单数：</span>
                  <span>{{buyerInfo.crediting_count||0}}单</span>
                </div>
                <div>
                  <span>未还欠款：</span>
                  <span style="font-szie:0.16rem">￥</span>
                  <span>{{buyerInfo.need_repayment_amount*1||0}}</span>
                </div>
                <div>
                  <div>最早未还订单日期：</div>
                  <div
                    v-if="buyerInfo.crediting_first_time"
                  >{{buyerInfo.crediting_first_time |toTime}}</div>
                  <div v-else>暂无</div>
                </div>
              </div>
            </div>
            <div class="bottom">
              <div
                class="toPay_btn"
                @click="toPay(type=1)"
                v-if="listQuery.buyer_id!=1 || buyerInfo.need_repayment_amount>0"
              >直接还款</div>
            </div>
          </div>
        </div>
        <!-- 右 -->
        <div class="goodPart">
          <!-- 列表 -->
          <div class="listBox brt4">
            <div class="listPart">
              <!-- :auto-reflow="true"
              :bouncing="false"-->
              <md-scroll-view ref="scrollView" :scrolling-x="false" @end-reached="$_onEndReached">
                <md-check-group v-model="checkedList" ref="checkedList" v-if="list">
                  <md-check
                    v-for="(item,index) in list"
                    :key="index"
                    :name="item.id"
                    :label="item.id"
                    class="list"
                    :disabled="item.status==1 || item.status==3 || item.status==4?true:false"
                  >
                    <!-- 补录赊欠 -->
                    <div class="listDetail" v-if="nowClick==5 || nowClick==2">
                      <div class="item1">
                        <div>
                          <span
                            v-for="(goods_item,goods_index) in item.orderTotal.goods"
                            :key="goods_index"
                          >
                            <span v-if="goods_index >0">,</span>
                            {{goods_item.name}}
                          </span>
                          <span v-if="item.order_id==0">补录订单</span>
                        </div>
                        <div v-if="item.order_id!=0">下单时间：{{item.create_time | toTime}}</div>
                        <div v-if="item.order_id==0">补录时间：{{item.create_time | toTime}}</div>
                      </div>
                      <div class="item2">
                        <template v-if="item.need_repayment_amount*1>0">
                          <div style="margin-top:0.04rem">
                            <span style="font-size:0.16rem;">￥</span>
                            {{item.need_repayment_amount*1}}
                          </div>
                          <div>未还欠款</div>
                        </template>
                      </div>
                      <div class="item3">
                        <div v-if="item.order_id==0">操作员：{{item.memberLink.realname}}</div>
                        <div v-if="item.order_id!=0">收银员：{{item.memberLink.realname}}</div>
                        <div v-if="item.orderTotal.order_sn">订单号：{{item.orderTotal.order_sn}}</div>
                      </div>
                      <div class="item4" @click.stop="lookDetail(item.orderTotal.order_sn)">
                        <span
                          style="background:rgba(49,177,88,.3);color:rgb(49, 177, 88)"
                          v-if="item.status==1"
                        >结清</span>
                        <span
                          style="background:rgba(255,0,0,.3);color:rgb(255, 0, 0)"
                          v-if="item.status==0"
                        >赊欠</span>
                        <!-- <span
                          style="background:rgba(153,153,153,.3);color:rgb(153, 153, 153)"
                          v-if="item.status==3"
                        >作废</span>
                        <span
                          style="background:rgba(49,177,88,.3);color:rgb(49, 177, 88)"
                          v-if="item.status==4"
                        >改单</span> -->
                        <md-icon name="arrow-right" size="sm" v-if="item.order_id!=0"></md-icon>
                      </div>
                    </div>
                    <!-- 全部、已还清 -->
                    <div class="listDetail" v-else>
                      <div class="item1">
                        <div>
                          <span v-for="(goods_item,goods_index) in item.goods" :key="goods_index">
                            <span v-if="goods_index >0">,</span>
                            {{goods_item.name}}
                          </span>
                        </div>
                        <div>下单时间：{{item.create_time | toTime}}</div>
                      </div>
                      <div class="item2">
                        <template v-if="item.need_repayment_amount*1>0">
                          <div style="margin-top:0.04rem">
                            <span style="font-size:0.16rem;">￥</span>
                            {{item.need_repayment_amount*1}}
                          </div>
                          <div>未还欠款</div>
                        </template>
                      </div>
                      <div class="item3">
                        <div>收银员：{{item.user_realname}}</div>
                        <div>订单号：{{item.order_sn}}</div>
                      </div>
                      <div class="item4" @click.stop="lookDetail(item.order_sn)">
                        <span
                          style="background:rgba(49,177,88,.3);color:rgb(49, 177, 88)"
                          v-if="item.status==1"
                        >结清</span>
                        <span
                          style="background:rgba(255,0,0,.3);color:rgb(255, 0, 0)"
                          v-if="item.status==2"
                        >赊欠</span>
                        <span
                          style="background:rgba(153,153,153,.3);color:rgb(153, 153, 153)"
                          v-if="item.status==3"
                        >作废</span>
                        <span
                          style="background:rgba(49,177,88,.3);color:rgb(49, 177, 88)"
                          v-if="item.status==4"
                        >改单</span>
                        <md-icon name="arrow-right" size="sm"></md-icon>
                      </div>
                    </div>
                  </md-check>
                </md-check-group>
                <md-scroll-view-more
                  :finished-text="list.length>0?'全部已加载':'暂无数据'"
                  slot="more"
                  :is-finished="isFinished"
                ></md-scroll-view-more>
              </md-scroll-view>
              <div v-if="list.length==0" class="listDetailEmpty">没有更多了~</div>
            </div>
          </div>
          <!-- 底部栏 -->
          <div class="checkBox" v-if="listQuery.buyer_id!=1">
            <div class="choose">
              <md-agree
                v-model="checkedAll"
                size="md"
                @change="handleCheckedAll(checkedAll, $event)"
              ></md-agree>
              <span>已选：{{chooseAmount}}元</span>
              <span>{{checkedList.length}}单</span>
            </div>
            <div
              class="pay_m"
              v-if="(listQuery.status!=1 && listQuery.buyer_id!=1) ||buyerInfo.need_repayment_amount>0"
              @click="toPay(type=2)"
            >
              <div>按单还款</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 订单详情 -->
    <orderDetail
      :pop_show="isShowDetail"
      :orderId="orderId"
      @cancel="isShowDetail=false;orderId = ''"
    />
    <!-- 还款 -->
    <toPay ref="toPay" @finish="handlePayFinish" />
    <!-- 编辑买家 -->
    <editBuyer ref="editBuyer" @finish="handleFinish" />
  </div>
</template>
<script>
import editBuyer from "../open/addBuyer";
import toPay from "./toPay";

import orderDetail from "../order/orderDetail";
import { timestampToDate, timestampToTime } from "@/utils/timestamp";
import { buyer_detail_order, buyer_detail_base } from "@/api/work/buyer";
import Calendar from "@/components/Calendar";
export default {
  name: "buyerDetail",
  components: {
    editBuyer,
    orderDetail,
    toPay,
    Calendar,
  },
  data() {
    return {
      tabLists: [
        { title: "全部订单", value: "" },
        { title: "已结清", value: 1 },
        { title: "赊欠", value: 2 },
        { title: "补录", value: 5 },
      ],
      nowClick: "", //当前点击
      searchTime: [],
      listQuery: {
        buyer_id: "",
        page: 1,
        pageSize: 15,
        status: "",
        name: "",
        from_time: "",
        to_time: "",
        order_type: 1,
        only_history: "",
      },
      list: [],
      isFinished: false,
      buyerInfo: {},

      isShowDetail: false, //是否显示订单详情
      orderId: "", //订单id

      checkedList: [],
      credit_ids: [],
      chooseAmount: 0, //按单还款选中金额

      checkedAll: false, // 是否全选
    };
  },
  watch: {
    checkedList: {
      handler(newValue, oldValue) {
        if (newValue.length < oldValue.length) {
          this.checkedAll = false;
        }
        this.computeTotal(newValue);
      },
      deep: true,
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name == "public_scan" && from.meta.backData.str) {
        vm.$refs.toPay.posPay(from.meta.backData.str);
      }
    });
  },
  created() {
    this.listQuery.buyer_id = this.$route.query.buyerId;
    this.getList();
    this.getBuyerInfo();
  },
  mounted() {},
  methods: {
    // 切换状态
    toggleTabs(i) {
      this.nowClick = i;
      this.listQuery.page = 1;
      if (this.nowClick == 5) {
        this.listQuery.status = "";
        this.listQuery.order_type = 2;
        this.listQuery.only_history = 1;
      } else if (this.nowClick == 2) {
        this.listQuery.status = 0;
        this.listQuery.order_type = 2;
        this.listQuery.only_history = "";
      } else {
        this.listQuery.status = i;
        this.listQuery.order_type = 1;
        this.listQuery.only_history = "";
      }
      this.$refs.scrollView.scrollTo(0, 0);
      this.checkedAll = false;
      this.getList();
    },
    //时间
    getTime(val) {
      if (this.searchTime) {
        this.listQuery.from_time = this.searchTime[0];
        this.listQuery.to_time = this.searchTime[1];
      } else {
        this.listQuery.from_time = "";
        this.listQuery.to_time = "";
      }
      this.listQuery.page = 1;
      this.getList();
    },
    //下拉刷新
    $_onEndReached() {
      if (this.isFinished) {
        return;
      }
      this.getList();
    },
    //获取列表
    getList() {
      if (this.listQuery.page == 1) {
        this.list = [];
        this.checkedList = [];
      }
      buyer_detail_order(this.listQuery).then((res) => {
        if (res.code == 200) {
          this.list = this.list.concat(res.data.list);
          if (
            this.list.length == res.data.totalCount ||
            res.data.list.length == 0
          ) {
            this.isFinished = true;
          } else {
            this.isFinished = false;
            this.listQuery.page++;
            this.checkedAll = false;
          }
          this.$nextTick(() => {
            this.$refs.scrollView.finishLoadMore();
          });
        }
      });
    },
    //获取买家信息
    getBuyerInfo() {
      buyer_detail_base({ id: this.listQuery.buyer_id }).then((res) => {
        if (res.code == 200) {
          this.buyerInfo = res.data;
        }
      });
    },
    // 全选
    handleCheckedAll(checked) {
      this.$refs.checkedList.toggleAll(checked);
    },
    // 计算总价
    computeTotal(array) {
      var amount = 0;
      var ids = [];
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i];
        if (array.includes(item.id)) {
          amount += item.need_repayment_amount - 0;
          ids.push(item.credit_id);
        }
      }
      this.credit_ids = ids;
      this.chooseAmount = Math.round(amount * 100) / 100;
    },

    // 去还款
    toPay(type) {
      if (type == 1) {
        //直接还款
        this.$refs.toPay.showPop(1, {
          buyer_name: this.buyerInfo.name,
          receivables: this.buyerInfo.need_repayment_amount,
          buyer_id: this.listQuery.buyer_id,
        });
      } else if (type == 2) {
        //按单还款
        if (this.checkedList.length == 0) {
          this.$toast.failed("请先选择订单！");
          return false;
        }
        this.$refs.toPay.showPop(2, {
          buyer_name: this.buyerInfo.name,
          receivables: this.chooseAmount,
          credit_ids: this.credit_ids.join(","),
        });
      }
    },
    // 还款完成
    handlePayFinish() {
      this.getBuyerInfo();
      this.checkedAll = false;
      this.listQuery.page = 1;
      this.getList();
    },

    // 买家编辑
    edit() {
      this.$refs.editBuyer.showPop(this.listQuery.buyer_id);
    },
    // 买家编辑完成
    handleFinish() {
      this.getBuyerInfo();
    },
    //看详情
    lookDetail(order_id) {
      if (order_id) {
        this.isShowDetail = true;
        this.orderId = order_id;
      } else {
      }
    },
  },
};
</script>
<style lang="less" scoped>
.buyerDetail {
  background: #e1e1e1;
  width: 100%;
  height: 100%;
  overflow: hidden;
  .contentBox {
    height: 100%;
    .top {
      display: flex;
      align-items: center;
      width: 100%;
      height: 0.7rem;
      // position: fixed;
      background: #e1e1e1;
      padding: 0rem 0.08rem;
      // left: 70px;
      // top: 54px;
      z-index: 100;
      .gback {
        color: #404040;
        width: 2.56rem;
        margin-right: 0.1rem;
      }
      .searchPart {
        display: flex;
        align-items: center;
        color: #404040;
        ul {
          display: flex;
          align-items: center;
          margin-right: 0.2rem;
          li {
            color: #31b158;
            width: 1.04rem;
            text-align: center;
            height: 0.42rem;
            line-height: 0.42rem;
            background: #fff;
            margin-right: 0.08rem;
            font-size: 0.2rem;
            border-radius: 0.04rem;
          }
          .active {
            color: #404040;
          }
        }
      }
    }
    .detail {
      width: 100%;
      height: calc(100% - 0.7rem);
      display: flex;
      padding: 0rem 0.1rem;
      .shop_part {
        width: 2.56rem;
        height: 100%;
        // padding-bottom: 10px;
        margin-right: 0.1rem;
        .shop_info {
          height: 100%;
          background: #fff;
          font-size: 0.2rem;
          display: flex;
          flex-direction: column;
          .shop_infotop {
            flex: 1;
            display: flex;
            flex-direction: column;
            .tlbox {
              padding: 0rem 0.12rem;
              padding-top: 0.16rem;
              padding-bottom: 0.12rem;
              border-bottom: 0.01rem solid #e5e5e5;
              .tl {
                display: flex;
                justify-content: space-between;
                align-items: center;
                div:nth-of-type(1) {
                  font-size: 0.28rem;
                  color: #404040;
                }
                div:nth-of-type(2) {
                  padding: 0.16rem;
                }
              }
              .phone {
                font-size: 0.2rem;
              }
            }
            .buyCountPart {
              padding: 0rem 0.12rem;
              padding-top: 0.2rem;
              line-height: 0.4rem;
              color: #404040;
              .buyCount {
                padding-bottom: 0.1rem;
                border-bottom: 0.01rem solid #e5e5e5;
                margin-bottom: 0.1rem;
              }
              div {
                // margin-bottom: 0.1rem;
                span:nth-of-type(1) {
                  color: #999999;
                }
              }
            }
            .creditPart {
              line-height: 0.4rem;
              padding: 0rem 0.12rem;
              div {
                // margin-bottom: 0.1rem;
                span:nth-of-type(1) {
                  color: #999;
                }
              }
              div:nth-of-type(4) {
                div:nth-of-type(1) {
                  margin-bottom: 0rem;
                  color: #999;
                }
              }
            }
          }
          .bottom {
            height: 0.72rem;
            display: flex;
            align-items: center;
            .toPay_btn {
              width: 1.6rem;
              height: 0.48rem;
              line-height: 0.48rem;
              display: flex;
              margin: 0 auto;
              justify-content: center;
              align-items: center;
              background: #31b158;
              font-size: 0.24rem;
              color: #fff;
              border-radius: 0.08rem;
            }
          }
        }
      }
      .goodPart {
        width: 10.12rem;
        height: 100%;
        display: flex;
        flex-direction: column;
        // margin-bottom: 72px;
        .listBox {
          width: 100%;
          // height: calc(100% - 0.72rem);
          flex: 1;
          overflow: hidden;
          background: #fff;
          .listPart {
            height: 100%;
            overflow: auto;
            .list {
              padding: 0.12rem 0rem;
              padding-left: 0.32rem;
              padding-right: 0.2rem;
              border-bottom: 0.01rem solid #e5e5e5;
              height: 0.84rem;
              .listDetail {
                display: flex;
                height: 0.6rem;
                .item1 {
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  margin-right: 0.7rem;
                  div:nth-of-type(1) {
                    color: #404040;
                    font-size: 0.24rem;
                    width: 2.4rem;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                  }
                  div:nth-of-type(2) {
                    color: #999999;
                    font-size: 0.16rem;
                  }
                }
                .item2 {
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  width: 1.78rem;
                  margin-right: 0.1rem;
                  div:nth-of-type(1) {
                    color: #404040;
                    font-size: 0.24rem;
                    color: #f79a07;
                  }
                  div:nth-of-type(2) {
                    color: #999999;
                    font-size: 0.16rem;
                  }
                }
                .item3 {
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  width: 2.52rem;
                  margin-right: 0.5rem;
                  div:nth-of-type(2) {
                    color: #999999;
                    font-size: 0.16rem;
                    width: 2.52rem;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                  }
                }
                .item4 {
                  display: flex;
                  align-items: center;
                  font-size: 0.2rem;
                  span {
                    padding: 0 0.1rem;
                    border-radius: 0.12rem;
                    margin-right: 0.3rem;
                    text-align: right;
                    font-size: 0.18rem;
                    line-height: 0.24rem;
                  }
                }
              }
            }
            .listDetailEmpty {
              text-align: center;
              color: #999;
            }
          }
        }

        .checkBox {
          width: 100%;
          height: 0.72rem;
          // position: fixed;
          // bottom: 0px;
          // right: 12px;
          background: #fff;
          box-shadow: 0rem 0rem 0.08rem 0rem rgba(30, 30, 30, 0.1);
          z-index: 100;
          padding: 0.2rem 0;
          padding-left: 0.22rem;
          padding-right: 0.2rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .choose {
            color: #404040;
            font-size: 0.24rem;
            font-weight: bold;
            display: flex;
            align-items: center;
            span:nth-of-type(1) {
              margin-right: 0.4rem;
            }
          }
          .pay_m {
            div {
              color: #fff;
              background: #31b158;
              width: 1.3rem;
              height: 0.48rem;
              text-align: center;
              line-height: 0.48rem;
              font-weight: normal;
              font-size: 0.24rem;
              border-radius: 0.08rem;
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="less">
.buyerDetail {
  .md-check {
    margin-top: 0;
    margin-bottom: 0;
    &.is-disabled {
      .item1,
      .item2,
      .item3 {
        * {
          color: #999 !important;
        }
      }
    }
  }
  .time {
    .Calendar {
      .calendar_select_box {
        background: #fff;
        height: 0.42rem;
      }
    }
  }
}
</style>